import React from 'react';
import ReactDOM from 'react-dom';
import { runWithAdal } from 'react-adal';

import 'react-widgets/dist/css/react-widgets.css';
import 'open-iconic/font/css/open-iconic-bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'loaders.css/loaders.min.css';
import './assets/css/index.css';

import App from './containers/App';
import { authContext } from './config/adal';

import * as serviceWorker from './serviceWorker';

if (process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render/dist/no-classes-transpile/umd/whyDidYouRender.min.js');
  whyDidYouRender(React);
}

runWithAdal(
  authContext,
  () => ReactDOM.render(<App />, document.getElementById('root')),
  true,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
